import { FC } from 'react';
import { Activity, ActivityType } from '../../graphql/generated/graphql.ts';
import { DeepPartial } from '@apollo/client/utilities';
import { Avatar, Breadcrumbs, Card, CardContent, Stack, Typography } from '@mui/material';

const renderType = (type: ActivityType) => {
  switch (type) {
    case ActivityType.Pleasant:
      return 'Pleasant';
    case ActivityType.Meaningful:
      return 'Meaningful / Challenging';
    case ActivityType.Social:
      return 'Social Connection';
  }
};

export interface ActivityProps {
  activity?: DeepPartial<Activity>;
}

export const ActivityView: FC<ActivityProps> = ({ activity }) => {
  if (!activity) {
    return null;
  }
  return (
    <Card
      sx={{
        borderLeft: `10px solid ${activity?.domain?.color}`,
        borderRadius: 3
      }}
    >
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
          {activity?.domain?.iconUrl && <Avatar src={activity?.domain?.iconUrl} />}
          <Stack>
            <Typography variant="h6">{activity?.description}</Typography>
            {activity?.subgoal && <Typography variant="subtitle1">Sub Goal: {activity.subgoal}</Typography>}
            <Breadcrumbs separator="•">
              <Typography variant="subtitle1">{activity?.domain?.title}</Typography>
              {activity?.type && <Typography variant="subtitle1">{renderType(activity.type)}</Typography>}
            </Breadcrumbs>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
